import { Button } from '@any-ui-react/core';
import { useState } from 'react';

import type { FilterProps } from '@/common/hooks/shared/useFilters';
import type { NumberOfEmployeesFilterType } from '@/common/types';

import { type ExportTypeCategory, NumberOfEmployeesExportModal } from '../export';

interface Props {
  defaultCategory: ExportTypeCategory;
  filters: FilterProps<NumberOfEmployeesFilterType>;
}

export const NumberOfEmployeesAction = ({ defaultCategory, filters }: Props) => {
  const [exportModalOpen, setExportModalOpen] = useState(false);

  return (
    <div className="flex space-x-4">
      <Button className="bg-white" variant="default" onClick={() => setExportModalOpen(true)}>
        Export
      </Button>
      <NumberOfEmployeesExportModal
        defaultCategory={defaultCategory}
        filters={filters}
        opened={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
      />
    </div>
  );
};
